
import { BrowserRouter, RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { AuthProvider } from "./components/auth/AuthProvider";
import { Toaster } from "./components/ui/toaster";
import { router } from "./routes";
import { LanguageProvider } from "./components/language/LanguageContext";
import { SidebarProvider } from "./components/ui/sidebar/context";
import { Platform } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import "./App.css";
import "./styles/device-specific.css";

// Konfigurer query client med bedre feilhåndtering
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        if (error?.code === 'session_expired') {
          console.log("Session expired, stopping retry");
          return false;
        }
        console.log(`Retry attempt ${failureCount} for query`);
        return failureCount < 3;
      },
      staleTime: 1000 * 60 * 5, // 5 minutter
      gcTime: 1000 * 60 * 30, // 30 minutter
    },
  },
});

function App() {
  const isWeb = Platform.OS === 'web';
  
  return (
    <ThemeProvider defaultTheme="light" attribute="class">
      <QueryClientProvider client={queryClient}>
        {isWeb ? (
          <AuthProvider>
            <LanguageProvider>
              <SidebarProvider>
                <RouterProvider router={router} />
                <Toaster />
              </SidebarProvider>
            </LanguageProvider>
          </AuthProvider>
        ) : (
          <AuthProvider>
            <LanguageProvider>
              <SidebarProvider>
                <StatusBar style="auto" />
                {/* For native mobile, implement a different routing solution here */}
              </SidebarProvider>
            </LanguageProvider>
          </AuthProvider>
        )}
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
